import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatAnchor, MatButton } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faBed,
  faHotTub,
  faMinus,
  faParking,
  faPlus,
  faSpoon,
  faWifi,
} from '@fortawesome/free-solid-svg-icons';
import { SeoService, UtilsService } from '@geekeno/ngx-website/services';
import * as AOS from 'aos';

@Component({
  selector: 'app-home',
  imports: [
    FontAwesomeModule,
    MatButton,
    MatAnchor,
    RouterLink,
    MatFormFieldModule,
    MatDatepickerModule,
    ReactiveFormsModule,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent implements OnInit {
  icons = {
    wifi: faWifi,
    parking: faParking,
    bed: faBed,
    restaurant: faSpoon,
    jacuzzi: faHotTub,
    plus: faPlus,
    minus: faMinus,
  };
  constructor(
    seo: SeoService,
    private utilsService: UtilsService,
  ) {
    seo.setSEO({
      title: 'Paradise has a new name | The Shore - Agonda',
      description:
        'Experience the beauty and tranquility of Agonda Beach at The Shore, a boho-chic resort with cozy cottages, a garden, a jacuzzi, and a restaurant. Enjoy the stunning views of the Arabian Sea, and the vibrant nightlife of South Goa. Book your stay today and get ready to relax, explore, and have fun at The Shore, Agonda.',
    });
  }
  ngOnInit() {
    if (this.utilsService.isPlatformBrowser) {
      AOS.init({ once: true });
    }
  }
}
